<script setup lang="ts">
import { ModalSubscriptionChangeProduct, ModalSubscriptionDiscount, ModalSubscriptionPause, ModalSubscriptionChangePause, ModalSubscriptionResume, ModalSubscriptionCancel, ModalSubscriptionPremiumTemplate, ModalSubscriptionAutoRenew, ModalSubscriptionSplit, ModalSubscriptionChargeNow } from '@widgets/subscriptions'
import { SubscriptionModal } from '@entities/subscription'

defineOptions({
  name: 'CustomerSubscriptionModals',
})

defineProps<{
  activeModal: SubscriptionModal | null
}>()

</script>

<template>
  <ModalSubscriptionChangeProduct v-if="activeModal === SubscriptionModal.ChangeProduct" />
  <ModalSubscriptionDiscount v-if="activeModal === SubscriptionModal.Discount" />
  <ModalSubscriptionPause v-if="activeModal === SubscriptionModal.Pause" />
  <ModalSubscriptionChangePause v-if="activeModal === SubscriptionModal.ChangePause" />
  <ModalSubscriptionResume v-if="activeModal === SubscriptionModal.Resume" />
  <ModalSubscriptionCancel v-if="activeModal === SubscriptionModal.Cancel" />
  <ModalSubscriptionPremiumTemplate v-if="activeModal === SubscriptionModal.PremiumTemplate" />
  <ModalSubscriptionAutoRenew v-if="activeModal === SubscriptionModal.AutoRenew" />
  <ModalSubscriptionSplit v-if="activeModal === SubscriptionModal.Split" />
  <ModalSubscriptionChargeNow v-if="activeModal === SubscriptionModal.ChargeNow" />
</template>
